import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import PageNotFoundViewModelType from './PageNotFoundViewModel.type';

type PageNotFoundType = PageNotFoundViewModelType & PageType;

export default (currentPage: PageType): currentPage is PageNotFoundType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Error_Pages_PageNotFoundViewModel;
};
